import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL_EXPENSE = `${config.URL_EXPENSES}/od`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BASE_URL_EXPENSE}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    if (error.response) {
      console.error(`HTTP Error ${error.response.status} in ${method.toUpperCase()} ${url}:`, error.response.data);
      throw new Error(`HTTP ${error.response.status}: ${error.response.data?.message || "Unknown error"}`);
    } else if (error.request) {
      console.error(`Network Error in ${method.toUpperCase()} ${url}: No response received.`);
      throw new Error("Network error: No response from server.");
    } else {
      console.error(`Error in ${method.toUpperCase()} ${url}:`, error.message);
      throw error;
    }
  }
};

// 🔹 Gestión de Grupos de Gastos (Grouped Expenses)
export const expenses_group_get = async (fi, ff) => request("get", "/grouped_expenses", null, { di: fi, df: ff });

export const expenses_group_ById_get = async (id) => request("get", `/grouped_expenses/${id}`);

export const expenses_group_delete = async (id) => request("delete", `/grouped_expenses/${id}`);

// 🔹 Políticas de Grupos de Gastos (Grouped Expenses Policies)
export const expenses_group_policy_get = async (id) => request("get", `/grouped_expenses/${id}/policy`);

export const expenses_group_policy_post = async (id) => request("post", `/grouped_expenses/${id}/policy`, {});

export const expenses_group_policy_put = async (id, idp, data,codAction) =>
  request("put", `/grouped_expenses/${id}/policy/${idp}`, data, { action: codAction });

export const expenses_group_policy_delete = async (id, idp) => request("delete", `/grouped_expenses/${id}/policy/${idp}`);

// 🔹 Detalles de Políticas de Grupo (Policy Details)
export const expenses_group_policy_details_get = async (id, idp) => request("get", `/grouped_expenses/${id}/policy/${idp}/details`);

export const expenses_group_policy_details_post = async (id, idp, data) =>
  request("post", `/grouped_expenses/${id}/policy/${idp}/details`, data);

export const expenses_group_policy_details_put = async (id, idp, idd, data) =>
  request("put", `/grouped_expenses/${id}/policy/${idp}/details/${idd}`, data);

export const expenses_group_policy_details_delete = async (id, idp, idd) =>
  request("delete", `/grouped_expenses/${id}/policy/${idp}/details/${idd}`);
